module.exports = "/static/media/empty_certificate_icon.42b6079c.svg";